import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiBarChart3,FiUsers,FiTrendingUp,FiTarget,FiSettings,FiBriefcase}=FiIcons;

const Services=()=> {
  const services=[
    {
      icon: FiTrendingUp,
      title: 'Sports Team Sales & Business Development',
      description: 'Comprehensive sales strategies and business development services designed to increase revenue streams and market penetration for professional and collegiate sports teams.',
      features: [
        'Season Ticket Sales Strategy',
        'Corporate Partnership Development', 
        'Sponsorship Sales & Management',
        'Fan Engagement & Retention Programs'
      ]
    },
    {
      icon: FiTarget,
      title: 'Sports Events Marketing & Sales',
      description: 'Strategic marketing and sales consulting for sports events, tournaments, and competitions to maximize attendance, sponsorship revenue, and brand visibility.',
      features: [
        'Event Marketing Strategy',
        'Ticket Sales Optimization',
        'Vendor & Sponsor Acquisition',
        'Audience Development & Analytics'
      ]
    },
    {
      icon: FiBriefcase,
      title: 'Sports Media Sales & Partnerships',
      description: 'Specialized sales and business development services for sports media companies, broadcasters, and digital platforms to expand market reach and revenue.',
      features: [
        'Advertising Sales Strategy',
        'Media Partnership Development',
        'Content Monetization',
        'Audience Growth & Engagement'
      ]
    },
    {
      icon: FiUsers,
      title: 'Client Acquisition & Pipeline Development',
      description: 'Strategic consulting focused on building robust sales pipelines and implementing effective client acquisition strategies across the sports industry.',
      features: [
        'Lead Generation Systems',
        'Sales Process Optimization',
        'CRM Implementation & Management',
        'Sales Team Training & Development'
      ]
    },
    {
      icon: FiBarChart3,
      title: 'Revenue Growth Analytics',
      description: 'Data-driven analysis and strategic planning to identify new revenue opportunities and optimize existing income streams for sports organizations.',
      features: [
        'Revenue Stream Analysis',
        'Market Opportunity Assessment',
        'Pricing Strategy Optimization',
        'Performance Metrics & Reporting'
      ]
    },
    {
      icon: FiSettings,
      title: 'Strategic Business Consulting',
      description: 'Comprehensive consulting services for sports organizations looking to optimize operations, expand market presence, and achieve sustainable growth.',
      features: [
        'Business Strategy Development',
        'Market Expansion Planning',
        'Operational Efficiency Improvement',
        'Competitive Analysis & Positioning'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our <span className="text-orange-600"> Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive sports industry consulting solutions designed to drive sales growth, enhance business development, and create sustainable competitive advantages.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service,index)=> (
            <motion.div
              key={service.title}
              initial={{opacity: 0,y: 50}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: index * 0.1}}
              whileHover={{y: -10}}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="mb-6">
                <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors duration-300">
                  <SafeIcon icon={service.icon} className="w-8 h-8 text-orange-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>

              <div className="space-y-3">
                {service.features.map((feature,featureIndex)=> (
                  <motion.div
                    key={feature}
                    initial={{opacity: 0,x: -20}}
                    whileInView={{opacity: 1,x: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.4,delay: (index * 0.1) + (featureIndex * 0.05)}}
                    className="flex items-center text-gray-600 text-sm"
                  >
                    <div className="w-2 h-2 bg-orange-600 rounded-full mr-3"></div>
                    {feature}
                  </motion.div>
                ))}
              </div>

              <motion.button
                whileHover={{scale: 1.02}}
                whileTap={{scale: 0.98}}
                className="w-full mt-6 bg-gray-50 hover:bg-orange-600 text-gray-700 hover:text-white py-3 rounded-xl font-semibold transition-all duration-300 border border-gray-200 hover:border-orange-600"
              >
                Learn More
              </motion.button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;